import { useSearchParams } from '@remix-run/react';

interface Props {
  tier: string;
  isLoggedIn: boolean;
}

const useUserStatus = ({ tier, isLoggedIn }: Props) => {
  const [searchParams] = useSearchParams();

  // isLoggedInOrSubscribed
  const subscribed = searchParams.get('status') === 'subscribed';
  const isLoggedInOrSubscribed = isLoggedIn || subscribed;

  // isPremiumSubscription
  const upgraded = searchParams.get('upgraded') === 'true';
  const isPremium = tier === 'premium';
  const isPremiumSubscription = isPremium || upgraded;

  return {
    isLoggedInOrSubscribed,
    isPremiumSubscription,
  };
};

export default useUserStatus;
